import { Constants } from '@shared/utils/constants';
import { getEntityRegistration } from '@shared/utils/entityRegistration';
import { routes } from '@shared/routerHistory';
import { PartnerSearchResultType } from '@shared/Models';
/**
 * Generates a URL for search navigation based on search parameters
 * @param buildHref - Function to build URL href
 * @param options - Search options
 * @returns The URL string to navigate to, or null if no valid route
 */ export function getSearchNavigationUrl(buildHref, options) {
    var _getEntityRegistration;
    const { gallery, searchTerm, useCurrentFilters } = options;
    const entityType = Constants.EntityType[`${gallery}`];
    const isPartner = entityType === Constants.EntityType.Partner;
    const route = isPartner ? routes.marketplacePartnerSuggestion : (_getEntityRegistration = getEntityRegistration(entityType)) === null || _getEntityRegistration === void 0 ? void 0 : _getEntityRegistration.route;
    if (!route) {
        return null;
    }
    if (isPartner) {
        return buildHref(route, null, {
            text: searchTerm,
            type: PartnerSearchResultType.FreeText.toString(),
            value: searchTerm
        });
    }
    if (useCurrentFilters) {
        return buildHref(route, null, {
            search: searchTerm,
            page: '1'
        });
    }
    return buildHref(route, null, {
        search: searchTerm,
        page: '1',
        [Constants.FilterQuery.category]: null,
        [Constants.FilterQuery.industry]: null,
        [Constants.FilterQuery.subcategories]: null,
        [Constants.FilterQuery.subindustries]: null,
        [Constants.FilterQuery.product]: null,
        [Constants.FilterQuery.filters]: null,
        serviceType: null
    });
}
